import { render, staticRenderFns } from "./HkBackground.vue?vue&type=template&id=7944a422&scoped=true&"
import script from "./HkBackground.vue?vue&type=script&lang=js&"
export * from "./HkBackground.vue?vue&type=script&lang=js&"
import style0 from "./HkBackground.vue?vue&type=style&index=0&id=7944a422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7944a422",
  null
  
)

export default component.exports